import * as React from 'react';
import { Edit, SimpleForm } from 'react-admin';
import { EditActionToolbar } from '../../common';
import Form from './Form';
import { useFailureNotify } from '../../../hooks';

export default props => {
  const notify = useFailureNotify();

  return (
    <Edit onFailure={notify} {...props} undoable={false}>
      <SimpleForm toolbar={<EditActionToolbar />}>
        <Form isEdit />
      </SimpleForm>
    </Edit>
  );
};
